import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { getProfile, Root as RootProfile } from "services/get-profile";

interface MetadataUser {
  profile: RootProfile | null;
}

const metadataUserContext = createContext<MetadataUser>({} as MetadataUser);

type MetadataUserProps = {
  children: ReactNode;
};

export const MetadataUserProvider = ({ children }: MetadataUserProps) => {
  const [profile, setProfile] = useState<RootProfile | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await getProfile();
        setProfile(profile);
      } catch (error) {
        setProfile(null);
      }
    };

    fetchProfile();
  }, []);

  return (
    <metadataUserContext.Provider
      value={{
        profile: profile,
      }}
    >
      {children}
    </metadataUserContext.Provider>
  );
};

export const useMetadataUser = () => {
  const context = useContext(metadataUserContext);
  return context;
};
